export const SECTION_MAXIMUM = 750;
export const FEEDBACK_MAXIMUM = 1150;

export function visibleText(value, html = true) {
  let content = String(value == null ? "" : value);
  if (!html && !/<\/?[a-z][^>]*>/i.test(content)) {
    return content.replace(/\r\n?/g, "\n");
  }
  if (html || /<\/?[a-z][^>]*>/i.test(content)) {
    const document = new DOMParser().parseFromString(content, "text/html");
    document.querySelectorAll("script, style").forEach(node => node.remove());
    document.querySelectorAll("br").forEach(node => {
      node.replaceWith(document.createTextNode("\n"));
    });
    document
      .querySelectorAll("p, div, li, h1, h2, h3, blockquote")
      .forEach(node => {
        node.appendChild(document.createTextNode("\n"));
      });
    content = document.body.textContent || "";
  }
  return content.replace(/\s+/g, " ").trim();
}

export function characterCount(value, html = true) {
  return Array.from(visibleText(value, html)).length;
}

export function reportSettingParts(key) {
  const match = String(key || "").match(
    /^(?:(.+)_)?(productive|receptive|grammar|speaking|comprehension)_(pre-a1|a1\+?|a2\+?|b1\+?|b2\+?|c1|c2)$/i
  );
  if (!match) return null;
  const kind = match[2].toLowerCase();
  const supported = match[1]
    ? ["productive", "receptive", "grammar"].includes(kind)
    : ["speaking", "comprehension"].includes(kind);
  return supported ? { prefix: match[1], kind, level: match[3] } : null;
}

export function settingDescription(setting, locale) {
  if (!setting) return "";
  if (locale === "en" && visibleText(setting.description_en)) {
    return setting.description_en;
  }
  return setting.description_es == null
    ? setting.value || ""
    : setting.description_es;
}

export function sectionCharacterCount(setting, settings, locale) {
  const parts = reportSettingParts(setting.key);
  if (!parts) return null;

  const contents = [settingDescription(setting, locale)];
  if (["receptive", "grammar"].includes(parts.kind)) {
    const otherKind = parts.kind === "receptive" ? "grammar" : "receptive";
    const otherKey = `${parts.prefix}_${otherKind}_${parts.level}`;
    const other = settings.find(
      item => item.key === otherKey && item.id !== setting.id
    );
    contents.push(settingDescription(other, locale));
  }
  return Array.from(
    contents
      .map(value => visibleText(value))
      .filter(Boolean)
      .join(" ")
  ).length;
}
